import React from 'react'
import { View, TouchableOpacity, Text, Button } from 'react-native'
import BaseContext from './BaseContext.js'
import Styles from './Styles.js'

const GrammarExplanation = (props) => {
  return (
    <BaseContext.Consumer>
      {({state, dispatch}) => (
          <React.Fragment>
            <View style={Styles.grammarTestExplanationHeader}>
              <Text style={Styles.grammarTestCasePromptText}>{state.word}</Text>
            </View>
            <View style={Styles.grammarTestExplanationBody}>
              <Text style={Styles.grammarExplanationSubHeaderText}>{state.wordDefinition.gender} {state.wordDefinition.partOfSpeech}</Text>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableHeading}></Text>
                <Text style={Styles.tableHeading}>Singular</Text>
                <Text style={Styles.tableHeading}>Plural</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Nominative</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.sn}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pn}</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Accusative</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.sa}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pa}</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Dative</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.sd}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pd}</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Genitive</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.sg}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pg}</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Locative</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.sl}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pl}</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Instrumentive</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.si}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pi}</Text>
              </View>
              <View style={Styles.tableRow}>
                <Text style={Styles.tableCell}>Vocative</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.sv}</Text>
                <Text style={Styles.tableCell}>{state.wordDefinition.declensions.pv}</Text>
              </View>
            </View>
            <View style={Styles.grammarTestCaseContainer}>
              <Button title="Back to question" onPress={ () => dispatch({type: 'HIDE_GRAMMAR_HELP'})} />
            </View>
          </React.Fragment>
        )
      }
    </BaseContext.Consumer>
  )
}

export default GrammarExplanation
